<template>
  <div class="investigation-page">
    <div class="investigation-shell">
      <div class="survey-module">
        <div class="survey-title-bar">理论培训满意度调查表</div>

        <div class="survey-card" v-loading="submitting">
          <div class="survey-intro">
            <p>尊敬的各位学员：</p>
            <p class="intro-content">
              欢迎您参加本期专科护士培训班的学习。为更好地做好专科护士培训工作，使培训班更符合临床护理工作发展的需求，切实协助您解决工作中的难点、疑点，真诚的希望您留下宝贵意见。谢谢合作！
            </p>
            <p class="intro-sign">山东省护理学会</p>
          </div>

          <section class="survey-section">
            <h3 class="section-title">
              一、参加学习班的动力及原因（在选择的答案上划“✓”，可以多项选择）
            </h3>
            <el-checkbox-group v-model="form.reasonList" class="options-inline">
              <el-checkbox label="1">领导安排</el-checkbox>
              <el-checkbox label="2">工作需要</el-checkbox>
              <el-checkbox label="3">主动要求</el-checkbox>
              <el-checkbox label="4">学习+休闲</el-checkbox>
              <el-checkbox label="5">电话邀请</el-checkbox>
            </el-checkbox-group>
          </section>

          <section class="survey-section">
            <h3 class="section-title">二、您对本期培训班的整体满意度</h3>

            <div class="question-item">
              <h4>1.培训班需要更新或添加的课程</h4>
              <el-input
                v-model.trim="form.coursesNeedUpdatedOrAdded"
                placeholder="请输入建议"
                clearable
              />
            </div>

            <div class="question-item">
              <h4>2.课程内容</h4>
              <el-radio-group
                v-model="form.courseContentSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.courseContentAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>

            <div class="question-item">
              <h4>3.时间安排</h4>
              <el-radio-group
                v-model="form.scheduleSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.scheduleAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>

            <div class="question-item">
              <h4>4.报名流程</h4>
              <el-radio-group
                v-model="form.enrollFlowSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.enrollFlowAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>

            <div class="question-item">
              <h4>5.培训考试</h4>
              <el-radio-group
                v-model="form.trainingExamSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.trainingExamAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>
          </section>

          <section class="survey-section">
            <h3 class="section-title">
              三、您对本期培训班的授课教师满意度（在选择的答案上划“√”，可以多项选择）
            </h3>
            <el-radio-group
              v-model="form.teacherSatisfaction"
              class="options-inline"
            >
              <el-radio label="1">最满意</el-radio>
              <el-radio label="2">比较满意</el-radio>
              <el-radio label="3">最不满意</el-radio>
            </el-radio-group>
          </section>

          <section class="survey-section">
            <h3 class="section-title">四、您对培训教材的满意度</h3>

            <div class="question-item">
              <h4>1.课程教材的实用性</h4>
              <el-radio-group
                v-model="form.materialPracticalSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
            </div>

            <div class="question-item">
              <h4>2.课程教材的内容</h4>
              <el-radio-group
                v-model="form.materialContentSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
            </div>

            <div class="question-item">
              <h4>3.课程教材的编排质量</h4>
              <el-radio-group
                v-model="form.materialQualitySatisfaction"
                class="options-inline"
              >
                <el-radio label="1">满意</el-radio>
                <el-radio label="2">可以,但需改进</el-radio>
                <el-radio label="3">不满意</el-radio>
              </el-radio-group>
            </div>

            <div class="question-item">
              <h4>4.您对课程及教材内容的改进意见是：</h4>
              <el-input
                v-model.trim="form.materialImproveAdvice"
                type="textarea"
                :rows="2"
                resize="none"
                placeholder="请输入改进意见"
              />
            </div>
          </section>

          <section class="survey-section">
            <h3 class="section-title">五、会务满意度调查</h3>

            <div class="question-item">
              <h4>1.省护理学会工作人员服务满意程度</h4>
              <el-radio-group
                v-model="form.workerServeSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">非常满意</el-radio>
                <el-radio label="2">满意</el-radio>
                <el-radio label="3">一般</el-radio>
                <el-radio label="4">较差</el-radio>
                <el-radio label="5">非常差</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.workerServeAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>

            <div class="question-item">
              <h4>2.学会组织流程满意程度</h4>
              <el-radio-group
                v-model="form.flowSatisfaction"
                class="options-inline"
              >
                <el-radio label="1">非常满意</el-radio>
                <el-radio label="2">满意</el-radio>
                <el-radio label="3">一般</el-radio>
                <el-radio label="4">较差</el-radio>
                <el-radio label="5">非常差</el-radio>
              </el-radio-group>
              <el-input
                v-model.trim="form.flowAdvice"
                placeholder="请输入建议"
                clearable
              />
            </div>
          </section>

          <section class="survey-section">
            <h3 class="section-title">六、意见与建议：</h3>
            <el-input
              v-model.trim="form.otherAdvice"
              type="textarea"
              :rows="2"
              resize="none"
              placeholder="其他建议及意见"
            />
          </section>

          <div class="survey-actions">
            <el-button
              class="submit-btn"
              :loading="submitting"
              :disabled="!arId"
              @click="submitSurvey"
            >
              提交
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

const SUBMITTED_SURVEY_CACHE_KEY = "pc_submitted_theory_survey_ar_ids";

export default {
  name: "Investigation",
  data() {
    return {
      submitting: false,
      arId: null,
      form: {
        reasonList: [],
        coursesNeedUpdatedOrAdded: "",
        courseContentSatisfaction: "1",
        courseContentAdvice: "",
        scheduleSatisfaction: "1",
        scheduleAdvice: "",
        enrollFlowSatisfaction: "1",
        enrollFlowAdvice: "",
        trainingExamSatisfaction: "1",
        trainingExamAdvice: "",
        teacherSatisfaction: "1",
        materialPracticalSatisfaction: "1",
        materialContentSatisfaction: "1",
        materialQualitySatisfaction: "1",
        materialImproveAdvice: "",
        workerServeSatisfaction: "1",
        workerServeAdvice: "",
        flowSatisfaction: "1",
        flowAdvice: "",
        otherAdvice: ""
      }
    };
  },
  created() {
    this.initArId();
  },
  methods: {
    initArId() {
      const arId = Number(this.$route.query.arId);
      if (Number.isFinite(arId) && arId > 0) {
        this.arId = arId;
        return;
      }
      this.arId = null;
      this.$message.warning("报名信息异常，无法提交调查问卷");
    },
    normalizeAdvice(text, fallback = "无") {
      const value =
        text === null || text === undefined ? "" : String(text).trim();
      return value || fallback;
    },
    getSubmittedSurveyArIdList() {
      try {
        const raw = sessionStorage.getItem(SUBMITTED_SURVEY_CACHE_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (error) {
        void error;
        return [];
      }
    },
    markSurveySubmitted(arId) {
      const currentArId = Number(arId);
      if (!Number.isFinite(currentArId) || currentArId <= 0) {
        return;
      }
      const list = this.getSubmittedSurveyArIdList();
      if (!list.includes(currentArId)) {
        list.push(currentArId);
      }
      sessionStorage.setItem(SUBMITTED_SURVEY_CACHE_KEY, JSON.stringify(list));
    },
    buildPayload() {
      return {
        arId: this.arId,
        reason: this.form.reasonList.join(","),
        coursesNeedUpdatedOrAdded: this.normalizeAdvice(
          this.form.coursesNeedUpdatedOrAdded
        ),
        courseContentSatisfaction: this.form.courseContentSatisfaction,
        courseContentAdvice: this.normalizeAdvice(
          this.form.courseContentAdvice
        ),
        scheduleSatisfaction: this.form.scheduleSatisfaction,
        scheduleAdvice: this.normalizeAdvice(this.form.scheduleAdvice),
        enrollFlowSatisfaction: this.form.enrollFlowSatisfaction,
        enrollFlowAdvice: this.normalizeAdvice(this.form.enrollFlowAdvice),
        trainingExamSatisfaction: this.form.trainingExamSatisfaction,
        trainingExamAdvice: this.normalizeAdvice(this.form.trainingExamAdvice),
        teacherSatisfaction: this.form.teacherSatisfaction,
        materialPracticalSatisfaction: this.form.materialPracticalSatisfaction,
        materialContentSatisfaction: this.form.materialContentSatisfaction,
        materialQualitySatisfaction: this.form.materialQualitySatisfaction,
        materialImproveAdvice: this.normalizeAdvice(
          this.form.materialImproveAdvice
        ),
        workerServeSatisfaction: this.form.workerServeSatisfaction,
        workerServeAdvice: this.normalizeAdvice(this.form.workerServeAdvice),
        flowSatisfaction: this.form.flowSatisfaction,
        flowAdvice: this.normalizeAdvice(this.form.flowAdvice),
        otherAdvice: this.normalizeAdvice(this.form.otherAdvice)
      };
    },
    async submitSurvey() {
      if (!this.arId) {
        this.$message.warning("报名信息异常，无法提交调查问卷");
        return;
      }
      if (
        !Array.isArray(this.form.reasonList) ||
        this.form.reasonList.length === 0
      ) {
        this.$message.warning("请选择参加学习班的动力及原因");
        return;
      }
      try {
        await this.$confirm("确认要提交调查问卷吗？", "提示", {
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        });
      } catch (error) {
        return;
      }

      this.submitting = true;
      try {
        const payload = this.buildPayload();
        const res = await httpRequest("/app/feedback/train", "post", payload);
        if (!(res && res.code === 200)) {
          return;
        }
        this.markSurveySubmitted(this.arId);
        this.$message.success("提交成功");
        this.$router.replace("/studyPage");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.investigation-page {
  min-height: calc(100vh - 77px - 50px);
  padding: 22px 0 30px;
  background: #efeff1;

  .investigation-shell {
    width: 1200px;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }

  .survey-module {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }

  .survey-title-bar {
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    background: #4095e5;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .survey-card {
    padding: 30px 40px 40px;
    text-align: left;
  }

  .survey-intro {
    color: #444a57;
    font-size: 15px;
    line-height: 1.8;
    border-bottom: 1px dashed #eceff4;
    padding-bottom: 20px;

    p {
      margin: 0;
    }

    .intro-content {
      margin-top: 10px;
      margin-bottom: 15px;
    }

    .intro-sign {
      margin-top: 8px;
      text-align: right;
    }
  }

  .survey-section {
    padding: 24px 0 10px;
    border-bottom: 1px dashed #eceff4;
  }

  .section-title {
    margin: 0 0 20px;
    font-size: 17px;
    color: #1f2530;
    font-weight: 600;
    line-height: 1.4;
    border-left: 4px solid #4095e5;
    padding-left: 10px;
  }

  .question-item {
    padding-bottom: 12px;

    &:not(:first-of-type) {
      margin-top: 14px;
    }

    h4 {
      margin: 0 0 10px;
      font-size: 16px;
      color: #2b303a;
      line-height: 1.45;
      font-weight: 600;
    }
  }

  .options-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 24px;
    margin-bottom: 10px;
  }

  .survey-actions {
    text-align: center;
    padding-top: 40px;

    .submit-btn {
      width: 280px;
      height: 48px;
      border: none;
      border-radius: 24px;
      background: #0f68c4;
      color: #ffffff;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s, opacity 0.2s, box-shadow 0.2s;
      letter-spacing: 2px;
      box-shadow: 0 4px 12px rgba(15, 104, 196, 0.3);

      &:hover:not(:disabled) {
        background: #1275db;
        box-shadow: 0 6px 16px rgba(15, 104, 196, 0.4);
      }

      &:active:not(:disabled) {
        background: #0c57a3;
      }

      &.is-disabled {
        background: #cccccc;
        color: #ffffff;
        cursor: not-allowed;
        box-shadow: none;
      }
    }
  }

  ::v-deep .el-checkbox__label,
  ::v-deep .el-radio__label {
    font-size: 14px;
    color: #444a57;
  }

  ::v-deep .el-input__inner {
    height: 38px;
    line-height: 38px;
    font-size: 16px;
  }

  ::v-deep .el-textarea__inner {
    font-size: 16px;
    line-height: 1.7;
  }
}

@media (max-width: 1200px) {
  .investigation-page {
    .section-title {
      font-size: 16px;
    }

    .question-item h4 {
      font-size: 14px;
    }

    ::v-deep .el-checkbox__label,
    ::v-deep .el-radio__label {
      font-size: 13px;
    }
  }
}
</style>
